import styled from 'styled-components';
import { KOGTableRow } from '@/main/components/shared/boxGrid/styles';

export const Container = styled(KOGTableRow)`
  &&& {
    .MuiIconButton-root.Mui-disabled {
      color: rgba(0, 0, 0, 0.34);
    }
  }
`;

export const CustomColumn = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

